import * as angular from "angular";

angular
  .module('bringoz.admin.devices')
  .constant('Devices_PN', {
    database: 'devices',
    isBranchEntity: false
  });
